const switchPositionBlockTyrPC = (position) => {
  if (position === undefined || position.length <= 2) {
    return arrayPosition[0];
  }
  if (position.length === 3) {
    return arrayPosition[1];
  }
  if (position.length === 4) {
    return arrayPosition[2];
  }
  if (position.length >= 5) {
    return arrayPosition[3];
  }
};

export { switchPositionBlockTyrPC };

const arrayPosition = [
  { top: "0px" },
  {
    top: "86px",
  },
  { bottom: "86px" },
  { bottom: "0px" },
];
